import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Grid,
} from "@mui/material";
import axios from "axios";

import apiService from "../../../../../ApiService";
import { API_ENDPOINTS } from "../../../../../ApiService";

const MuscleGroupTable = ({ title, groups }) => {
  // Group the muscle groups by region
  const groupedByRegion = groups.reduce((acc, group) => {
    const region = group.region || "Other";
    if (!acc[region]) {
      acc[region] = [];
    }
    acc[region].push(group);
    return acc;
  }, {});

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {title}
      </Typography>
      {Object.entries(groupedByRegion).map(([region, regionGroups]) => (
        <Box key={region} sx={{ mb: 3 }}>
          <Typography
            variant="h6"
            sx={{
              backgroundColor: "#1976d2",
              color: "#fff",
              p: 1,
              borderRadius: 1,
            }}
          >
            {region}
          </Typography>
          <TableContainer component={Paper} sx={{ mt: 1 }}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#eeeeee" }}>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      fontWeight: "bold",
                      py: 0.5,
                      px: 2,
                    }}
                  >
                    Name
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      fontWeight: "bold",
                      py: 0.5,
                      px: 2,
                    }}
                  >
                    French Name
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      fontWeight: "bold",
                      py: 0.5,
                      px: 2,
                    }}
                  >
                    Description
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      fontWeight: "bold",
                      py: 0.5,
                      px: 2,
                    }}
                  >
                    Region
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: "left",
                      fontWeight: "bold",
                      py: 0.5,
                      px: 2,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {regionGroups.map((group) => (
                  <TableRow
                    key={group.id}
                    sx={{
                      backgroundColor: "#ffffff",
                      "&:hover": { backgroundColor: "#e0e0e0" },
                      height: 40,
                    }}
                  >
                    <TableCell sx={{ textAlign: "left", py: 0.5, px: 2 }}>
                      {group.name}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left", py: 0.5, px: 2 }}>
                      {group.frenchName}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left", py: 0.5, px: 2 }}>
                      {group.description}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left", py: 0.5, px: 2 }}>
                      {group.region}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left", py: 0.5, px: 2 }}>
                      {group.action}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ))}
    </Box>
  );
};

const MuscleGroupListingPage = () => {
  const [muscleGroups, setMuscleGroups] = useState([]);

  useEffect(() => {
    const fetchMuscleGroups = async () => {
      try {
        const response = await apiService.get(API_ENDPOINTS.FITNESS_GET_MUSCLE);
        setMuscleGroups(response.data);
      } catch (error) {
        console.error("Error fetching muscle groups:", error);
      }
    };
    fetchMuscleGroups();
  }, []);

  // Separate into upper and lower body groups
  const upperBodyGroups = muscleGroups.filter(
    (group) => group.bodyPart === "Upper Body"
  );
  const lowerBodyGroups = muscleGroups.filter(
    (group) => group.bodyPart === "Lower Body"
  );
  const coreBodyGroups = muscleGroups.filter(
    (group) => group.bodyPart === "Core"
  );

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 4 }}>
        Muscle Groups
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <MuscleGroupTable title="Upper Body" groups={upperBodyGroups} />
        </Grid>
        <Grid item xs={12} md={6}>
          <MuscleGroupTable title="Lower Body" groups={lowerBodyGroups} />
        </Grid>
        <Grid item xs={12} md={6}>
          <MuscleGroupTable title="Core" groups={coreBodyGroups} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MuscleGroupListingPage;
